import TabTrapMixin from '@mixins/tab-trap'

export default {
  name: 'tab-trap',
  mixins: [TabTrapMixin],
  props: {
    focusFirst: Boolean
  },
  computed: {
    noInitialFocus() {
      return true
    }
  },
  watch: {
    focusFirst(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.firstFocusableEl.focus()
          }, 200)
        })
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
      this.activatorEl.focus()
    }
  },
  render() {
    return this.$scopedSlots.default({})
  }
}